var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#14086D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5C13.8647 7.5 10.5 10.718 10.5 14.6719C10.5 16.5548 11.3583 19.0589 13.0509 22.1147C14.4103 24.5681 15.983 26.7867 16.8009 27.8906C16.9392 28.0792 17.1199 28.2326 17.3284 28.3384C17.537 28.4441 17.7676 28.4992 18.0014 28.4992C18.2352 28.4992 18.4658 28.4441 18.6744 28.3384C18.8829 28.2326 19.0637 28.0792 19.2019 27.8906C20.0184 26.7867 21.5925 24.5681 22.9519 22.1147C24.6417 19.0598 25.5 16.5558 25.5 14.6719C25.5 10.718 22.1353 7.5 18 7.5ZM18 18C17.4067 18 16.8266 17.8241 16.3333 17.4944C15.8399 17.1648 15.4554 16.6962 15.2284 16.1481C15.0013 15.5999 14.9419 14.9967 15.0576 14.4147C15.1734 13.8328 15.4591 13.2982 15.8787 12.8787C16.2982 12.4591 16.8328 12.1734 17.4147 12.0576C17.9967 11.9419 18.5999 12.0013 19.148 12.2284C19.6962 12.4554 20.1648 12.8399 20.4944 13.3333C20.8241 13.8266 21 14.4067 21 15C20.9991 15.7954 20.6828 16.5579 20.1204 17.1204C19.5579 17.6828 18.7954 17.9991 18 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvg);
export default __webpack_public_path__ + "static/media/locationSvg.2c83b039876d9024df5fb65e4d10ffb5.svg";
export { ForwardRef as ReactComponent };